export default __webpack_public_path__ + "static/media/plan-icon.55738830.svg";